import React from "react";

function UserTable() {
    return (
        <div className="divergence-table table-responsive mb-0">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col" className="mw-120">First Name</th>
                        <th scope="col" className="mw-120">Last Name</th>
                        <th scope="col" className="mw-160">Email</th>
                        <th scope="col" className="mw-120">Is Trading</th>
                        <th scope="col" className="mw-120">Confirmed</th>
                        <th scope="col" className="mw-120">Customer Stripe</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Ms Trader</td>
                        <td>Jane</td>
                        <td className="action">Info@diveregencecapital.com</td>
                        <td>no</td>
                        <td>no</td>
                        <td className="green"></td>
                    </tr>
                    <tr>
                        <td>John</td>
                        <td>Smith</td>
                        <td className="action">gytag@mailto.plus</td>
                        <td>no</td>
                        <td>yes</td>
                        <td className="green">cus_LxtLjPx3Vm7aZA</td>
                    </tr>
                    <tr>
                        <td>Ms Trader</td>
                        <td>Jane</td>
                        <td className="action">Info@diveregencecapital.com</td>
                        <td>no</td>
                        <td>no</td>
                        <td className="green"></td>
                    </tr>
                    <tr>
                        <td>John</td>
                        <td>Smith</td>
                        <td className="action">gytag@mailto.plus</td>
                        <td>no</td>
                        <td>yes</td>
                        <td className="green">cus_LxtLjPx3Vm7aZA</td>
                    </tr>
                    <tr>
                        <td>Ms Trader</td>
                        <td>Jane</td>
                        <td className="action">Info@diveregencecapital.com</td>
                        <td>no</td>
                        <td>no</td>
                        <td className="green"></td>
                    </tr>
                    <tr>
                        <td>John</td>
                        <td>Smith</td>
                        <td className="action">gytag@mailto.plus</td>
                        <td>no</td>
                        <td>yes</td>
                        <td className="green">cus_LxtLjPx3Vm7aZA</td>
                    </tr>
                    <tr>
                        <td>Ms Trader</td>
                        <td>Jane</td>
                        <td className="action">Info@diveregencecapital.com</td>
                        <td>no</td>
                        <td>no</td>
                        <td className="green"></td>
                    </tr>
                    <tr>
                        <td>John</td>
                        <td>Smith</td>
                        <td className="action">gytag@mailto.plus</td>
                        <td>no</td>
                        <td>yes</td>
                        <td className="green">cus_LxtLjPx3Vm7aZA</td>
                    </tr>
                    <tr>
                        <td>Ms Trader</td>
                        <td>Jane</td>
                        <td className="action">Info@diveregencecapital.com</td>
                        <td>no</td>
                        <td>no</td>
                        <td className="green"></td>
                    </tr>
                    <tr>
                        <td>John</td>
                        <td>Smith</td>
                        <td className="action">gytag@mailto.plus</td>
                        <td>no</td>
                        <td>yes</td>
                        <td className="green">cus_LxtLjPx3Vm7aZA</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default UserTable;